import Head from 'next/head';
import { ReactNode, useState } from 'react';
import Header from 'components/headers/Header';
import Container from './Container';

type BlwLayoutProps = {
  background: string;
  size: string;
  withContainer: boolean;
  className: string;
  isHome: boolean;
  isAuthenticated: boolean;
  withNoFlex: boolean;
  noPadding: boolean;
  isMobile: boolean;
  noPaddingMobile: boolean;
  backgroundTop: boolean;
  name: string;
  vh100: boolean;
  children: ReactNode;
  stretch: boolean;
};

const BlwLayout = ({
  background,
  size,
  withContainer = true,
  className,
  isHome,
  isAuthenticated,
  withNoFlex,
  noPadding,
  isMobile,
  noPaddingMobile,
  backgroundTop,
  name,
  vh100,
  children,
  stretch,
}: BlwLayoutProps) => {
  const pageBackground = /\.(gif|jpg|jpeg|tiff|png)$/i.test(background) ? `url(${background})` : background;

  const classes = [
    'blw PageWrapper NavOffCanvas-push js-off-canvas-item js-off-canvas-close',
    !withContainer || withNoFlex ? 'PageWrapper--noflex PageWrapper--ip-flex' : '',
    isAuthenticated ? 'loggedIn' : '',
    isHome ? 'isHome' : '',
    isMobile ? 'isMobile' : '',
    vh100 ? 'vh100' : '',
    noPadding ? 'u-pb0 u-sm-pb5' : '',
    noPaddingMobile ? 'u-sm-pb0' : '',
    backgroundTop ? 'PageWrapper--backgroundTop' : '',
    `page-blw-${name}`,
  ]
    .join(' ')
    .trim();

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
        <title>List your Boat</title>
      </Head>
      <div>
        <Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} isHome={false} />
      </div>
      <main>
        <div id="bg-image-div" className={`${classes}`} style={{ backgroundImage: pageBackground }}>
          <div
            style={{
              paddingTop: '60px',
            }}
            className={`PageWrapper-content w-100 h-100 ${className || ''} ${
              stretch && 'u-flexAlignItemsStretch'
            } u-ip-pv0 u-pt4 u-sm-pt0`}
          >
            {withContainer ? (
              <Container withNav={false} size={size}>
                {children}
              </Container>
            ) : (
              children
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default BlwLayout;
